import React from 'react';

/**
 * Lungs icon — anatomical silhouette, renders identically to Lucide icons.
 * Uses vector-effect="non-scaling-stroke" so the stroke width stays unaffected
 * by the inner scale(0.1) transform from potrace output.
 */
const LungsIcon = ({ className = '', strokeWidth = 2, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={strokeWidth}
    className={className}
    aria-hidden="true"
    {...rest}
  >
    {/*
      The potrace path uses a 980-unit coordinate system with a (translate, scale -0.1) flip.
      We wrap it so the rendered area still fits the 24×24 viewBox, while the stroke width
      remains anchored to the OUTER viewBox (24), giving an exact match with Lucide icons.
    */}
    <g
      transform="translate(0, 24) scale(0.00244898, -0.00244898)"
      vectorEffect="non-scaling-stroke"
    >
      <path
        vectorEffect="non-scaling-stroke"
        d="M4462 8527 c-22 -23 -22 -23 -22 -613 0 -590 0 -590 -43 -632 -43 -42 -43 -42 -874 -42 -931 0 -836 26 -1101 -303 -576 -718 -989 -1683 -1421 -3327 -69 -263 -161 -612 -175 -665 -21 -77 -44 -155 -98 -335 -164 -539 -178 -788 -61 -1012 154 -293 474 -394 1017 -319 646 89 1693 399 1990 589 570 365 888 1108 957 2237 20 332 1 956 -40 1265 -11 83 -16 76 155 232 237 216 193 204 330 89 171 -141 157 -115 140 -262 -72 -591 -72 -1321 0 -1819 132 -914 486 -1535 1032 -1809 291 -146 1131 -395 1637 -485 633 -112 924 -76 1145 144 225 223 237 512 50 1125 -71 234 -133 452 -195 695 -26 102 -72 277 -102 390 -30 113 -59 219 -63 235 -18 70 -116 406 -172 590 -99 326 -261 784 -354 1002 -24 57 -44 105 -44 107 0 2 -18 43 -40 90 -22 47 -40 88 -40 90 0 8 -167 345 -213 431 -178 331 -413 663 -654 923 -94 102 -94 102 -936 102 -841 0 -841 0 -884 42 -43 42 -43 42 -43 633 0 592 0 592 -23 613 -38 36 -822 34 -855 -1z"
      />
    </g>
  </svg>
);

export default LungsIcon;
